import React from "react";
import EndorsementLine from "./endorsement_line";

const FullCourse = function FullCourse(props) {
    return (
        <div className="card coursebox" title={"For year " + props.datayear}>
            <div className="card-content">
                <div className="content">
                    <div className="columns container">
                        <div className="column is-three-fifths has-text-centered">
                            <h2 className="title is-4">{props.literal}</h2>
                        </div>
                        <div className="column is-one-fifth">
                            <strong className="is-size-7">Course Code</strong>
                            <div className="title is-5">{props.code}</div>
                        </div>
                    </div>
                    <hr />
                    <div className="container coursecontent">
                        {
                            props.description ?
                            props.description.split('\n').map( (item, i) =>{
                                return <p key={i}>{item}</p>;
                            })
                                : ''
                        }
                    </div>
                    <div className="container endorsements">
                        <div className="columns">
                            <div className="column is-one-third"></div>
                            <div className="column is-two-thirds">
                                <div className="columns">
                                    <div className="column">
                                        <div className="has-text-centered has-background-dark has-text-white endorsementdisclaimer">Clearing Endorsement --- Endorsement Level must be in accord with student grade level:</div>
                                    </div>
                                </div>
                                <div className="columns">
                                    <div className="column">
                                        <strong>Endorsement Name</strong>
                                    </div>
                                    <div className="column has-text-centered">
                                        <strong>Endorsement Number</strong>
                                    </div>
                                </div>
                                { props.endorsements.length ?
                                    props.endorsements.map( (item, key) => {
                                        return (
                                            <EndorsementLine key={key} name={item.endorsement ? item.endorsement.literal : 'UNKNOWN ERROR'} code={item.endorsement_code} />
                                        )})
                                    : ''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FullCourse;
